import React, { useState } from "react";
import Slider from "react-slick"; // Assuming you're using react-slick for sliders
import { SketchPicker } from "react-color"; // For color picker
import IconCollection from '../../IconCollection/IconCollection';
import DraggableTeamOnePlayer from './DraggableTeamOnePlayer';
import DroppableTeamTwoPlayer from './DroppableTeamTwoPlayer';
import DraggableTeamTwoPlayer from './DraggableTeamTwoPlayer';
import DroppableTeamOnePlayer from './DroppableTeamOnePlayer';
import ActionMessageComponent from './ActionMessageComponent';
import { playerAssistSelection, resetScoreTemporaryData, setOpenStarterModal, togglePossessionArrowTeamOne, togglePossessionArrowTeamTwo, updatePostingDataReset } from '../../redux/reducers/playersReducer';
import { useSelector } from 'react-redux';
import { GrPlayFill, GrPlay } from "react-icons/gr";



const MatchComponent = ({
  matchStatus,
  foulPT,
  foul,
  missPT,
  playerSelectionsTeamTwo,
  playerSelectionsTeamOne,
  teamReboundSections,
  actionPlayerId,
  turnoverSelections,
  foulActionsSelections,
  playerPointSelect,
  teamOneColorSection,
  setTeamOneColorSection,
  teamOneColor,
  handleTeamOneColor,
  teamOneName,
  teamOnePlayingPlayer,
  handlePlayerSelectionOne,
  handlePlayerSelectionTwo,
  handlePlayerTeamOneDrop,
  handleBackClick,
  teamPointCount,
  teamTwoColorSection,
  setTeamTwoColorSection,
  handleTeamTwoColor,
  teamTwoName,
  teamTwoColor,
  teamTwoPlayingPlayer,
  handlePlayerTeamTwoDrop,
  setTeamTab,
  matchData,
  findPlayerTeam,
  teamOneBench,
  teamTwoBench,
  message,
  actionSteps,
  dispatch,
  isLoadingOne,
  setIsLoadingOne,
  isLoadingTwo,
  setIsLoadingTwo,
  shotClockCheck,
  playerPersonalFoulCount,
  assistSelections, cancelStep, undoStep,
  shortSelections, shortFieldSelections, event_team_a_id, event_id, event_group_id, quarter, minutes, seconds, token, event_team_b_id, foulActions, toActions, reboundSelections, teamAssistSections, miss3PT, miss2PT, miss1PT, made3PT, made1PT, made2PT
}) => {
  const teamOnePlayerSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    draggable: false,
    swipe: false,
    nextArrow: (
      <div className="lg:max-w-[44px] w-full h-[44px] cursor-pointer rounded l flex justify-center items-center">
        <IconCollection
          name="arrow-right"
          customClass="lg:max-w-[25px] max-w-[10.16px] w-full lg:h-[24px] h-[10.16px]"
        />
      </div>
    ),
    prevArrow: (
      <div className="max-w-[44px] w-full h-[44px] cursor-pointer left-0 rounded flex justify-center items-center">
        <IconCollection
          name="arrow-left"
          customClass="lg:max-w-[25px] max-w-[10.16px] w-full lg:h-[24px] h-[10.16px]"
          svgFillColor="#7D7D7D"
        />
      </div>
    ),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const teamTwoPlayerSettings = {
    dots: false,
    infinite: false,
   speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    draggable: false,
    swipe: false,
    nextArrow: (
      <div className="max-w-[44px] w-full h-[44px] cursor-pointer rounded flex justify-center items-center">
        <IconCollection
          customClass="lg:max-w-[25px] max-w-[10.16px] w-full lg:h-[24px] h-[10.16px]"
          name="arrow-right"
        />
      </div>
    ),

    prevArrow: (
      <div className="max-w-[44px] w-full h-[44px] cursor-pointer left-0 rounded flex justify-center items-center">
        <IconCollection
          customClass="lg:max-w-[25px] max-w-[10.16px] w-full lg:h-[24px] h-[10.16px]"
          name="arrow-left"
          svgFillColor="#7D7D7D"
        />
      </div>
    ),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // const [isLoadingOne, setIsLoadingOne] = useState(false);
  // const [isLoadingTwo, setIsLoadingTwo] = useState(false);
  const [draggedPlayerTeamOne, setDraggedPlayerTeamOne] = useState(null); // New state for drag data
  const [draggedPlayerTeamTwo, setDraggedPlayerTeamTwo] = useState(null); // New state for drag data
  const [targetedPlayerTeamOne, setTargetedPlayerTeamOne] = useState(null); // New state for drag data
  const [targetedPlayerTeamTwo, setTargetedPlayerTeamTwo] = useState(null); // New state for drag data

  const cancelBtn = () => {
    dispatch(playerAssistSelection())
    dispatch(resetScoreTemporaryData())
    dispatch(updatePostingDataReset())
  };
const {possessionArrowTeamOne, possessionArrowTeamTwo} = useSelector(
    (state) => state?.playersReducer
  );
  return (
    <div className="xxl:max-w-[570px] xxl:min-w-[570px] lg:max-w-[596px] lg:min-w-[596px] max-w-[244px] min-w-[244px] w-full pl-0 lg:pl-0  lg:p-2 p-1 flex flex-col gap-3 lg:gap-6 relative">
      {matchStatus === "liveEnd" && (
        <div className="absolute z-10 bg-transparent left-0 right-0 top-0 bottom-0 w-full h-full "></div>
      )}

      {/* Player Selection and Color Configuration for Team One */}
      <div className="flex flex-col gap-[10px] relative">
        {!foulPT && !foul && !missPT && playerSelectionsTeamTwo && (
          <div className="w-full 1 bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}
        {missPT && playerSelectionsTeamTwo && !playerSelectionsTeamOne && (
          <div className="w-full 2 bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}

        {missPT && teamReboundSections === "Block" && findPlayerTeam(actionPlayerId) === "teamA" && (
          <div className="w-full 3 bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}
        {foul && turnoverSelections && playerSelectionsTeamOne && (
          <div className="w-full 4 bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}
        {foulPT && foulActionsSelections && playerSelectionsTeamOne && (
          <div className="w-full 5 bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}

        <div className="flex items-center gap-2 relative">
          {playerPointSelect && (
            <div className="w-full 6 bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
          )}
          <button
            disabled={matchStatus === "liveEnd" || isLoadingOne}
            onClick={() => {
             dispatch(setOpenStarterModal(true));
              setTeamTab("team1");
            }}
            className="lg:max-w-[44px] max-w-5 w-full lg:h-[44px] h-5 custom-drop-shadow cursor-pointer rounded flex justify-center items-center"
          >
            <IconCollection name="change-icon" customClass="lg:w-6 lg:h-6 w-[10px] h-[10px]" />
          </button>

          <div className="flex justify-center items-center w-full">
            <div className={`w-full teamOneSideMainContainer ${teamOneBench?.length < 7 ? "lg:max-w-fit" : "lg:max-w-[415px] max-w-[140px] lg:ml-10 ml-5"}`}>
              <Slider {...teamOnePlayerSettings} className="w-full">
                {matchData?.team_a_rosters
                  ?.filter(player => !player.is_Playing && player.is_present)
                  ?.sort((a, b) => a.jersey_number - b.jersey_number)
                  ?.map((player, index) => (
                    <div key={index}>
                      <DraggableTeamOnePlayer
                        isLoadingOne={isLoadingOne}
                        setIsLoadingOne={setIsLoadingOne}
                        player={player}
                        teamOneColor={teamOneColor}
                        targetedPlayerTeamOne={targetedPlayerTeamOne}
                        draggedPlayerTeamOne={draggedPlayerTeamOne}
                        setTargetedPlayerTeamOne={setTargetedPlayerTeamOne}
                        setDraggedPlayerTeamOne={setDraggedPlayerTeamOne}
                      />
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
        </div>

        {/* Droppable Team One Players */}
        <div className="flex gap-1 items-center justify-center">
          {teamOnePlayingPlayer
            ?.sort((a, b) => a.jersey_number - b.jersey_number)
            ?.map((player, index) => (
              <DroppableTeamOnePlayer
                key={index}
                isLoadingOne={isLoadingOne}
                setIsLoadingOne={setIsLoadingOne}
                player={player}
                onPlayerDrop={handlePlayerSelectionOne}
                playerId={player.roster_id}
                playerPersonalFoulCount={playerPersonalFoulCount}
                actionPlayerId={actionPlayerId}
                assistSelections={assistSelections}
                shortSelections={shortSelections}
                shortFieldSelections={shortFieldSelections}
                event_team_a_id={event_team_a_id}
                event_id={event_id}
                event_group_id={event_group_id}
                quarter={quarter}
                minutes={minutes}
                seconds={seconds}
                token={token}
                matchData={matchData}
                handlePlayerSelectionOne={handlePlayerSelectionOne}
                dispatch={dispatch}
                teamOneColor={teamOneColor}
                targetedPlayerTeamOne={targetedPlayerTeamOne}
                draggedPlayerTeamOne={draggedPlayerTeamOne}
                setTargetedPlayerTeamOne={setTargetedPlayerTeamOne}
                setDraggedPlayerTeamOne={setDraggedPlayerTeamOne}

              />
            ))}
        </div>

        {/* Team One Score and Color Selection */}
        <div className="flex gap-1 lg:gap-2">
          <div className="max-w-[54px] w-full lg:p-2 p-1 flex lg:flex-col flex-row gap-1 lg:gap-2 bg-light custom-drop-shadow lg:rounded-md rounded-[2.54px] relative">
            {playerPointSelect && (
              <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
            )}
            <button
              disabled={matchStatus === "live" || matchStatus === "liveEnd"}
              onClick={() => setTeamOneColorSection(!teamOneColorSection)}
              className="lg:max-w-[38px] max-w-5 relative w-full lg:h-[34px] h-auto disabled:bg-slate-300 bg-[#E8E8E8] lg:rounded rounded-[1.69px] flex justify-center items-center cursor-pointer"
            >
              <IconCollection name={teamOneColorSection ? "close" : "pencil-icon"} customClass="lg:w-6 lg:h-6 w-[10px] h-[10px]" />
            </button>
            {teamOneColorSection && (
              <div className="absolute z-10 top-0 left-16">
                <SketchPicker color={teamOneColor} onChangeComplete={handleTeamOneColor} />
              </div>
            )}
            <div
              style={{ backgroundColor: `${teamOneColor}` }}
              className="lg:max-w-[38px] max-w-[20px] flex-1 w-full lg:rounded rounded-[1.69px] lg:h-[50px] h-auto"
            ></div>
          </div>
          <div className="bg-light lg:rounded-md rounded-[2.54px] flex w-full ">

                <button
              onDoubleClick={() => dispatch(togglePossessionArrowTeamOne())}
              className='pl-2  lg:text-4xl text-base -mt-[5px] lg:-mt-[10px]'>

              {possessionArrowTeamOne ? <GrPlayFill  className=''/> : <GrPlay  className='text-primary'/>}
            </button>


            <div
              style={{ color: `${teamOneColor}` }}
              className="font-bebas text-left lg:text-center max-w-auto lg:text-[64px]  text-base flex-1 flex lg:flex-col flex-row justify-between lg:border-r-[1px] border-r-[0.42px] p-1 lg:p-2 lg:leading-[70px] leading-[20px] border-[#E8E8E8] lg:justify-center items-center"
            >
              <span className='max-w-[90px] overflow-hidden truncate lg:max-w-full'>
                {teamOneName}
            </span>

              <div className="lg:hidden flex gap-[2px] items-center">
                {[...Array(5)].map((_, idx) => (
                  <div key={idx} className="border-[0.67px] rounded-full h-1 lg:h-2 w-1 lg:w-2" style={{ borderColor: teamOneColor }}></div>
                ))}
              </div>
            </div>
            <div style={{ color: `${teamOneColor}` }} className="lg:max-w-[108px] max-w-[33px] relative w-full h-auto font-bebas lg:text-[64px] text-[20px] flex justify-center items-center">
              {playerPointSelect && (
                <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
              )}
              {teamPointCount(event_team_a_id)}
            </div>
          </div>
        </div>
      </div>
      {/* Navigation and Back Button */}
      <div className="w-full rounded-[2.54px] lg:rounded-md bg-white lg:border-[1px] border-[0.42px] flex border-[#CCCCCC] lg:min-h-[64px] min-h-8">
        <button
          // disabled={matchStatus === "liveEnd" || undoStep === 0}
          onClick={handleBackClick}
          className="lg:max-w-[100px] max-w-10 w-full flex h-full lg:gap-2 gap-1 cursor-pointer justify-center items-center"
        >
          <IconCollection customClass="lg:max-w-6 lg:max-w-4 max-w-3 w-full lg:h-6 lg:h-4 h-3" name="back-icon" />
          <p className="font-bebas text-[10px] lg:text-xs  text-[#4A4A4A]">Back</p>
        </button>

        <div className="flex justify-start items-center w-full px-3 border-[#CCCCCC] border-l-[1px]">
          <ActionMessageComponent
            made2PT={made2PT}
            made1PT={made1PT}
            made3PT={made3PT}
            miss1PT={miss1PT}
            miss2PT={miss2PT}
            miss3PT={miss3PT}
            shortFieldSelections={shortFieldSelections}
            shortSelections={shortSelections}
            assistSelections={assistSelections}
            teamAssistSections={teamAssistSections}
            reboundSelections={reboundSelections}
            teamReboundSections={teamReboundSections}
            toActions={toActions}
            foulActions={foulActions}
            turnoverSelections={turnoverSelections}
            foulActionsSelections={foulActionsSelections}
          />
          <button
            disabled={actionSteps === 1}
            onClick={() => cancelBtn()}
            className="w-[72px] h-full cursor-pointer flex justify-center items-center disabled:text-gray-300 lg:text-base text-[10px]"
          >
            Cancel
          </button>
        </div>
      </div>
      {/* Similar structure for Team Two */}
      <div className="flex flex-col gap-[10px] relative">
        {!foulPT && !foul && !missPT && playerSelectionsTeamOne && (
          <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}
        {missPT && playerSelectionsTeamOne && !playerSelectionsTeamTwo && (
          <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}
        {missPT && teamReboundSections === "Block" && findPlayerTeam(actionPlayerId) === "teamB" && (
          <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}
        {foul && turnoverSelections && playerSelectionsTeamTwo && (
          <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}
        {foulPT && foulActionsSelections && playerSelectionsTeamTwo && (
          <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}

        <div className="flex gap-1 lg:gap-2">
          <div className="max-w-[54px] w-full lg:p-2 p-1 flex lg:flex-col flex-row gap-1 lg:gap-2 bg-light custom-drop-shadow lg:rounded-md rounded-[2.54px] relative">
            {playerPointSelect && (
              <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
            )}
            <button
              disabled={matchStatus === "live" || matchStatus === "liveEnd"}
              onClick={() => setTeamTwoColorSection(!teamTwoColorSection)}
              className="lg:max-w-[38px] max-w-5 relative w-full lg:h-[34px] h-auto disabled:bg-slate-300 bg-[#E8E8E8] lg:rounded rounded-[1.69px] flex justify-center items-center cursor-pointer"
            >
              <IconCollection customClass="lg:w-6 lg:h-6 w-[10px] h-[10px]" name={teamTwoColorSection ? "close" : "pencil-icon"} />
            </button>
            {teamTwoColorSection && (
              <div className="absolute z-10 top-0 left-16">
                <SketchPicker color={teamTwoColor} onChangeComplete={handleTeamTwoColor} />
              </div>
            )}
            <div
              style={{ backgroundColor: `${teamTwoColor}` }}
              className="lg:max-w-[38px] max-w-[20px] flex-1 w-full lg:rounded rounded-[1.69px] lg:h-[50px] h-auto"
            ></div>
          </div>

          <div className="bg-light lg:rounded-md rounded-[2.54px] flex w-full ">

               <button onDoubleClick={() => dispatch(togglePossessionArrowTeamTwo())} className='pl-2 lg:text-4xl text-base -mt-[5px] lg:-mt-[10px]'>
              {possessionArrowTeamTwo ? <GrPlayFill  className=''/> : <GrPlay  className='text-primary'/>}
            </button>

            <div
              style={{ color: `${teamTwoColor}` }}
              className="font-bebas text-left lg:text-center lg:text-[64px]  text-base flex-1 flex lg:flex-col flex-row justify-between lg:border-r-[1px] border-r-[0.42px] p-1 lg:p-2 lg:leading-[70px] leading-[20px] border-[#E8E8E8] lg:justify-center items-center"
            >    <span className='max-w-[90px] overflow-hidden truncate lg:max-w-full'>
                             {teamTwoName}
            </span>

              <div className="lg:hidden flex gap-[2px] items-center">
                {[...Array(5)].map((_, idx) => (
                  <div key={idx} className="border-[0.67px] rounded-full h-1 lg:h-2 w-1 lg:w-2" style={{ borderColor: teamTwoColor }}></div>
                ))}
              </div>
            </div>
            <div
              style={{ color: `${teamTwoColor}` }}
              className="lg:max-w-[108px] max-w-[33px] relative w-full h-auto font-bebas lg:text-[64px] text-[20px] flex justify-center items-center"
            >
              {playerPointSelect && (
                <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
              )}
              {teamPointCount(event_team_b_id)}
            </div>
          </div>
        </div>

        {/* Droppable Team Two Players */}
        <div className="flex gap-1 items-center justify-center">
          {teamTwoPlayingPlayer
            ?.sort((a, b) => a.jersey_number - b.jersey_number)
            ?.map((player, index) => (
              <DroppableTeamTwoPlayer
                key={index}
                isLoadingTwo={isLoadingTwo}
                setIsLoadingTwo={setIsLoadingTwo}
                player={player}
                onPlayerDrop={handlePlayerSelectionTwo}
                playerId={player.roster_id}
                playerPersonalFoulCount={playerPersonalFoulCount}
                actionPlayerId={actionPlayerId}
                assistSelections={assistSelections}
                shortSelections={shortSelections}
                shortFieldSelections={shortFieldSelections}
                event_team_b_id={event_team_b_id}
                event_id={event_id}
                event_group_id={event_group_id}
                quarter={quarter}
                minutes={minutes}
                seconds={seconds}
                token={token}
                matchData={matchData}
                handlePlayerSelectionTwo={handlePlayerSelectionTwo}
                dispatch={dispatch}
                teamTwoColor={teamTwoColor}
                setTargetedPlayerTeamTwo={setTargetedPlayerTeamTwo}
                draggedPlayerTeamTwo={draggedPlayerTeamTwo}
                setDraggedPlayerTeamTwo={setDraggedPlayerTeamTwo}
                targetedPlayerTeamTwo={targetedPlayerTeamTwo}
              />
            ))}
        </div>

        <div className="flex items-center gap-[2px] relative mb-[15px]">
          {playerPointSelect && (
            <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
          )}
          <button
            disabled={matchStatus === "liveEnd" || isLoadingTwo}
            onClick={() => {
              dispatch(setOpenStarterModal(true));
              setTeamTab("team2");
            }}
            className="lg:max-w-[44px] max-w-5 w-full lg:h-[44px] h-5 custom-drop-shadow cursor-pointer rounded flex justify-center items-center"
          >
            <IconCollection name="change-icon" customClass="lg:w-6 lg:h-6 w-[10px] h-[10px]" />
          </button>

          <div className="flex justify-center items-center w-full">
            <div className={`w-full teamOneSideMainContainer ${teamTwoBench?.length < 7 ? "lg:max-w-fit" : "lg:max-w-[415px] max-w-[140px] lg:ml-10 ml-5"}`}>
              <Slider {...teamTwoPlayerSettings} className="w-full">
                {matchData?.team_b_rosters
                  ?.filter(player => !player.is_Playing && player.is_present)
                  ?.sort((a, b) => a.jersey_number - b.jersey_number)
                  ?.map((player, index) => (
                    <div key={index}>
                      <DraggableTeamTwoPlayer
                        setDraggedPlayerTeamTwo={setDraggedPlayerTeamTwo}
                        targetedPlayerTeamTwo={targetedPlayerTeamTwo}
                        isLoadingTwo={isLoadingTwo}
                        setIsLoadingTwo={setIsLoadingTwo}
                        player={player}
                        teamTwoColor={teamTwoColor}
                        draggedPlayerTeamTwo={draggedPlayerTeamTwo}
                      />
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default MatchComponent;
